import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget';

import type { TArrow, TArrowDeps } from './models';

import { Arrow as Component } from './index';

export const ArrowDesktop = createWidget<TArrowDeps, TArrow>({
    Button,
})(Component);
